exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,\r\n.btn, \r\n.input-group-addon, \r\n.form-control {\r\n    font-size: 18px !important; \r\n}\r\n\r\n.test1 {\r\n    position: relative; \r\n    z-index: 25; \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main